module.exports = __webpack_public_path__ + "img/signal-alt-slash.2745020c.svg";